import React, { useEffect, useState } from 'react';
import { 
  SafeAreaView, View, Text, StyleSheet, ScrollView, TouchableOpacity, 
  Image, ActivityIndicator, Platform 
} from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import ShimmerPlaceHolder from 'react-native-shimmer-placeholder';
import { LinearGradient } from 'expo-linear-gradient';

const API_URL = "https://collabbay.com/APIControllers/FetchSimilarVenues.php";
const IMAGE_BASE = "https://collabbayadmin.com/listings/";
const FALLBACK = "https://images.pexels.com/photos/1058277/pexels-photo-1058277.jpeg";

const firstImage = (v) => {
  if (!v) return FALLBACK;
  const first = String(v).split(",")[0].trim();
  return first.startsWith("http") ? first : IMAGE_BASE + first;
};

const SimilarVenues = ({ route, navigation }) => {
  const listingID = route?.params?.ListingID; // ✅ Dynamic real ID

  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(true);
  const [imgLoad, setImgLoad] = useState({});

  useEffect(() => {
    if (!listingID) return;
    fetch(`${API_URL}?listing_id=${listingID}`)
      .then(res => res.json())
      .then(json => setResults(json.matches || []))
      .finally(() => setLoading(false));
  }, [listingID]);

  const goHome = () => {
    if (Platform.OS === 'web') window.location.href = "/";
    else navigation.navigate("Homepage");
  };

  return (
       <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center', backgroundColor: '#fff' }}>
     <SafeAreaView style={[styles.container, { width: '100%', maxWidth: 600, alignSelf: 'center', backgroundColor: '#fff', flex: 1 }]}>     
      {/* Back & Close */}
      <TouchableOpacity style={styles.backBtn} onPress={() => navigation.goBack()}>
        <Ionicons name="arrow-back" size={28} color="#000" />
      </TouchableOpacity>
      
      <TouchableOpacity style={styles.exitBtn} onPress={goHome}>
        <Ionicons name="close" size={30} color="#000" />
      </TouchableOpacity>

      <ScrollView contentContainerStyle={styles.wrap} showsVerticalScrollIndicator={false}>
        
        <Text style={styles.title}>Whilst you're booking...</Text>
        <Text style={styles.subTitle}>Similar offers</Text>

        {loading && <ActivityIndicator size="large" color="#000" style={{ marginTop:20, }} />}

        <View style={styles.cardHolder}>
        {results.map(item => (
          <TouchableOpacity 
            key={item.ListingID} 
            style={styles.card}
            onPress={() => navigation.navigate('CreateSubmissionPage', { ListingID: item.ListingID })}
            activeOpacity={0.92}
          >
            {/* Banner */}
            <ShimmerPlaceHolder
              LinearGradient={LinearGradient}
              style={styles.banner}
              shimmerColors={['#e0e0e0','#f3f3f3','#e0e0e0']}
              visible={imgLoad[item.ListingID]}
            >
              <Image
                style={styles.banner}
                source={{ uri: firstImage(item.LogoImage) }}
                onLoad={() => setImgLoad(p => ({ ...p, [item.ListingID]: true }))}
              />
            </ShimmerPlaceHolder>

            {/* Category */}
            <View style={styles.catBadge}>
              <Text style={styles.catText}>{item.OfferCategory}</Text>
            </View>

            <View style={styles.info}>
              <Text style={styles.brand}>{item.BrandName}</Text>
              {!!item.NonCreditOffer && (
                <Text style={styles.offer}>{item.NonCreditOffer}</Text>
              )}
              <Text style={styles.value}>£{item.Credits} value</Text>

              <View style={styles.locRow}>
                <Ionicons name="location-outline" size={14} color="#000" />
                <Text style={styles.location}>{item.Location}</Text>
              </View>
            </View>

          </TouchableOpacity>
        ))}
        </View>

        <TouchableOpacity style={styles.homeBtn} onPress={goHome}>
          <Text style={styles.homeText}>Back to home</Text>
        </TouchableOpacity>

      </ScrollView>

    </SafeAreaView>
    </View>

  );
};

export default SimilarVenues;

const CARD_HEIGHT = 245; // ensures 3 fit nicely
const BANNER_HEIGHT = 110;

const styles = StyleSheet.create({
  wrap:{ paddingTop:70, paddingHorizontal:18, paddingBottom:50 },

  backBtn:{ position:"absolute", top:18, left:18, zIndex:99 },
  exitBtn:{ position:"absolute", top:18, right:18, zIndex:99 },

  title:{
    fontSize:26,
    fontWeight:"700",
    color:"#000",
    marginBottom:4,
  },
  subTitle:{
    fontSize:20,
    fontWeight:"600",
    color:"#555",
    marginBottom:18,
  },

  cardHolder:{
    gap:18,
    marginBottom:22
  },

  card:{
    backgroundColor:"#ffffff",
    borderRadius:18,
    overflow:"hidden",
    height:CARD_HEIGHT,
    shadowColor:"#000",
    shadowOpacity:0.07,
    shadowRadius:9,
    shadowOffset:{ width:0, height:4 },
    elevation:2,
    borderWidth:0.5,
    borderColor:"#e9e9e9"
  },

  banner:{
    width:"100%",
    height:BANNER_HEIGHT,
    backgroundColor:"#f2f2f2"
  },

  catBadge:{
    position:"absolute",
    top:12,
    left:12,
    backgroundColor:"rgba(253,240,93,0.85)",
    paddingHorizontal:10,
    paddingVertical:3,
    borderRadius:8
  },
  catText:{
    fontSize:11,
    fontWeight:"600",
    color:"#000"
  },

  info:{ padding:12 },

  brand:{
    fontSize:18,
    fontWeight:"700",
    marginBottom:2,
    color:"#000"
  },

  offer:{
    fontSize:15,
    fontWeight:"400",
    color:"#444",
    marginBottom:4
  },

  value:{
    fontSize:19,
    fontWeight:"700",
    color:"#000",
    marginBottom:6
  },

  locRow:{
    flexDirection:"row",
    alignItems:"center",
    opacity:0.75
  },
  location:{
    fontSize:13,
    marginLeft:4,
    fontWeight:"500",
    color:"#000"
  },

  homeBtn:{
    backgroundColor:"#000",
    paddingVertical:12,
    borderRadius:12,
    marginTop:6
  },
  homeText:{
    color:"#fff",
    fontWeight:"600",
    textAlign:"center",
    fontSize:15
  }
});
